import React from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

import Copyright from '../../Copyright/Copyright'

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignUp(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Avatar className={classes.avatar} src="logo.png" />
        <Typography component="h1" variant="h5">
          {t('SignUp')}
        </Typography>
        <form className={classes.form} noValidate onSubmit={props.handleSignUp}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="name"
                name="name"
                variant="outlined"
                required
                fullWidth
                id="name"
                label={t('FormLabels.Name')}
                autoFocus
                value={props.name}
                onChange={e => props.setName(e.target.value)}
                error={props.nameError}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label={t('FormLabels.Email')}
                name="email"
                type="email"
                autoComplete="email"
                value={props.email}
                onChange={e => props.setEmail(e.target.value)}
                error={props.emailError}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="phone"
                label={t('FormLabels.Mobile')}
                name="phone"
                type="tel"
                autoComplete="phone"
                value={props.phone}
                onChange={e => props.setPhone(e.target.value)}
                error={props.phoneError}
                InputProps={{
                  startAdornment: <TextField
                select
                value={props.phoneCountry}
                onChange={e => props.setPhoneCountry(e.target.value)}
            >
              {
                Object.entries(t('TelephoneCountries', { returnObjects: true })).map((countryMap) => (<MenuItem key={countryMap[0]} value={countryMap[0]}>{countryMap[1]}</MenuItem>))
              }
            </TextField>,
                }}
          />              
            </Grid>
            {/* <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox value="allowExtraEmails" color="primary" />}
                label="I want to receive inspiration, marketing promotions and updates via email."
              />
            </Grid> */}
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={props.loading}
          >
            {t('SignUp').toUpperCase()}
            &nbsp;
            {props.loading && <CircularProgress size={24}/>}
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link variant="body2" onClick={props.goToSignIn} href="#">
                {t('HaveAccount')}
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
}